import { useList } from '../../../../api/react-query';

export function useConfigList({ params,config }) {
  const { data, isLoading, refetch, isFetching, isRefetching } = useList(
    'config/configs',
    { ...params },
    { ...config },
  );

  return {
    data: data?.data?.data,
    count: data?.data?.totalCount,
    isLoading: isLoading || isFetching || isRefetching,
    refetch,
  };
}
